import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';

function ViewOnly(props) {

    return (
        <span data-test="view-only" className={props.classes.viewOnly}>(View only)</span>
    );

}

ViewOnly.propTypes = {
    classes: PropTypes.object
};

export default withStyles(styles)(ViewOnly);